import { useEffect, useState } from "react";
import { InsightsInstallModal } from "../InsightsInstallModal";

export function RFMAnalysisLockView() {
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <InsightsInstallModal open={isModalOpen} onOpenChange={setIsModalOpen} />
  );
}
